import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/manager';

const find = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/reservationSettings`, {
		branchId,
	});
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/reservationSettings`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/reservationSettings/${id}`,
		payload
	);
};

export default {
	find,
	create,
	update,
};
